import React, { useMemo } from 'react';
import ErrorBoundary from '@components/tailwind/ErrorBoundary';
import { createRoot } from 'react-dom/client';
import Element from './features/cms/components/Element';
import useABTests from './hooks/useABTests';
import { Provider } from 'react-redux';
import testStore from "@/store/testStore";

const DropdownRoot = (props) => {
  useABTests();

  const elements = useMemo(() => {
    return JSON.parse(props.elements);
  }, [props.elements]);

  return (<>
      {elements.map((e, i) =>
          <Element key={i} {...e} navCenterItemsClasses={props.navCenterItemsClasses}/>)}
  </>);
};

const rootEl = document.getElementById('DropdownRoot');

if (rootEl) {
  createRoot(rootEl).render(
    <ErrorBoundary silent>
      <Provider store={testStore}>
        {React.createElement(DropdownRoot, rootEl.dataset)}
      </Provider>
    </ErrorBoundary>
  );
}
